module.exports = __webpack_public_path__ + "051cbdc10fd7d61808b0968638e47104.png";